import { Body, Icon } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

import { Suggestion } from '../custom-extensions/SlashMenuRenderer';

export const SlashMenuItem = ({
  action,
  index,
  command,
  focused,
}: {
  action: Suggestion;
  index: number;
  command: (action: Suggestion) => void;
  focused: boolean;
}) => {
  const ref = React.useRef<HTMLLIElement>(null);
  React.useEffect(() => {
    if (focused) {
      ref.current?.focus();
    }
  }, [focused, index]);
  return (
    <li
      ref={ref}
      className={clsx(
        'flex flex-row items-center px-4 py-2 cursor-pointer hover:bg-primary-hover rounded',
        focused && 'bg-primary-hover',
        index === 3 &&
          'border-solid border-t-0 border-l-0 border-r-0 border-b border-divider-card',
      )}
      key={action.title}
      onClick={() => {
        command?.(action);
      }}
      tabIndex={index}
    >
      {action.icon && <Icon icon={action.icon} className="h-3 w-3 mr-2" />}
      <Body className="font-normal text-base text-primary">{action.title}</Body>
    </li>
  );
};
